import React, { Component } from 'react';
import Stack from 'react-bootstrap/Stack';
import BodyIcon from '../../components/BodyIcon/BodyIcon';
import StatModel from '../../models/StatModel';
import Strings from 'localization/Strings';
import Summary from '../../components/Summary/SummaryComponent';
import './Searching.css';

class Effort extends Component {
    totalDuration = 2000; // miliseconds
    decreasingStepPercent = 15; // percent in each step
    constructor(props){
        super(props);
        this.onNext = props.onNext;
        this.onRestart = props.onRestart;
        this.state = {activePercent: 90};
        this.bodyIcon = <BodyIcon activePercent="10"/>;
        this.model = props.model;
        this.accessToken = props?.accessToken;
    }

    componentDidMount() {
        let N = 100 / this.decreasingStepPercent;
        let eachInterval = this.totalDuration / N;
        this.backend_result_promiss = StatModel.fetchTheResultFromTheBackend(this.model, this.accessToken);
        this.interval = setInterval(() => {
            this.tick();
        }, eachInterval);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async tick(){
        let currentPercent = this.state.activePercent;
        let newPercent = Math.max(currentPercent - this.decreasingStepPercent, 0);
        await this.setState({activePercent: newPercent});
        this.bodyIcon = <BodyIcon activePercent="10"/>
        if (newPercent === 0) {
            clearInterval(this.interval);
            this.timeout = setTimeout(() => {
                this.backend_result_promiss.then((result) => {
                    if (result) {
                        this.onNext(result);
                    }
                    else{
                        this.onRestart();
                    }
                });
            }, 1000);
        }
    }

    render () {
        return (
            <Stack  gap={0} >
                <div className='mb-5'>
                    <Summary model={this.model} className="" />
                </div>
                <div className="my-card ms-auto" bg="light">
                    <h2 className="text-xl font-weight-bold">{Strings.strings.Searching.Description}</h2>
                </div>
                <div className="mt-3">
                    <BodyIcon activePercent={this.state.activePercent} />
                </div>
            </Stack>
        );
    }
}

export default Effort;